import React, { useEffect } from 'react';
import RefundPolicy from './RefundPolicy';

const TracsessOrganizeRefund: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <RefundPolicy
      appName="Tracsess Organize"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/organize/R+%26+C+Policy_Tracsess_Organize.pdf"
      title="Tracsess Organize - Refund and Cancellation Policy"
    />
  );
};

export default TracsessOrganizeRefund; 